(function () {
  const STORAGE_KEY = 'hommox:collection-view';
  const VIEWS = ['list', '2', '3', '4'];
  const COL_CLASSES = ['grid--1-col-desktop', 'grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop'];

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function currentViewFromGrid(grid) {
    if (!grid) return null;
    if (grid.classList.contains('grid--view-list')) return 'list';
    const match = Array.from(grid.classList).find((className) => /^grid--\d-col-desktop$/.test(className));
    return match ? match.replace('grid--', '').replace('-col-desktop', '') : null;
  }

  function applyView(view) {
    const grid = getGrid();
    if (!grid || !VIEWS.includes(view)) return;

    grid.classList.remove(...COL_CLASSES, 'grid--view-list');
    if (view === 'list') {
      grid.classList.add('grid--1-col-desktop', 'grid--view-list');
    } else {
      grid.classList.add(`grid--${view}-col-desktop`);
    }

    grid.querySelectorAll('.card').forEach((card) => {
      card.classList.toggle('card--horizontal', view === 'list');
    });

    document.querySelectorAll('.view-toggle__button').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.view === view));
    });
  }

  function setView(view) {
    applyView(view);
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) — view still applies for this page load.
    }
  }

  function restoreView() {
    let stored = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      stored = null;
    }
    const view = stored && VIEWS.includes(stored) ? stored : currentViewFromGrid(getGrid());
    if (view) applyView(view);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.view-toggle__button');
    if (!button) return;
    setView(button.dataset.view);
  });

  restoreView();

  const container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(restoreView).observe(container, { childList: true });
  }
})();
